import { Box, Divider, InputAdornment } from '@mui/material';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormNumberInput } from '../../../../../component/form/FormNumberInput';
import { FinancesDrawerFormValues } from '../RightDrawerSchema';

type Props = {
  control: Control<FinancesDrawerFormValues>;
};

export const FinancesSpecialCaseView = ({ control }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Box sx={{ ml: '8%' }}>
        <FormNumberInput
          control={control}
          name="service.apiconSpecialCase.priceGross"
          label=""
          helperText={t('deals.new.financesConfiguration.calculationDrawer.rate.rateIncludingVAT')}
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          shrink
          disableUnderline
          disabled
        />
      </Box>

      <Divider orientation="vertical" flexItem />

      <Box sx={{ ml: '8%' }}>
        <FormNumberInput
          control={control}
          name="service.apiconSpecialCase.priceNet"
          label=""
          helperText={t('deals.new.financesConfiguration.calculationDrawer.rate.rateExcludingVAT')}
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          shrink
          disableUnderline
          disabled
        />
      </Box>

      <Divider orientation="vertical" flexItem />

      <Box sx={{ ml: '8%' }}>
        <FormNumberInput
          control={control}
          name="service.apiconSpecialCase.vatAsValue"
          label=""
          helperText={t('deals.new.financesConfiguration.calculationDrawer.rate.VAT')}
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          shrink
          disableUnderline
          disabled
        />
      </Box>
    </>
  );
};
